/*
 * @developerName: 邓科峰
 * @Function name:
 * @Date: 2025-12-09 10:01:33
 * @param:
 * @LastEditor:
 * @LastData:
 * @Describe:
 */
// api/task.js
import request from './axios'

// 获取任务列表
export function getTaskList (data) {
  return request({
    url: `/map.php?type=${'get_list'}`,
    method: 'get',
    params: data
  })
}

// 创建任务
export function createTask (data) {
  return request({
    url: '/map.php?type=add_list',
    method: 'post',
    data: data,
    isFormData: true
  })
}

// 登录用户
export function loginList () {
  return request({
    url: `/map.php?type=${'login'}`,
    method: 'get'
  })
}

// 获取任务详情
export function getTaskDetail (id) {
  return request({
    url: `/tasks/${id}`,
    method: 'get'
  })
}
// 接收任务
export function acceptTask (data) {
  return request({
    url: '/map.php?type=get_task',
    method: 'post',
    data: data,
    isFormData: true
  })
}
// 完成任务
export function completeTask (data) {
  return request({
    url: '/map.php?type=finish_task',
    method: 'post',
    data: data,
    isFormData: true
  })
}



// WEBPACK FOOTER //
// ./src/utils/api.js